import axios from 'axios'
import AscentiaService from './ascentiaService'
import {
  startDateGivenTimeline,
  endDateGivenTimeline,
} from '../utilities/dates'

const values = {}

const getters = {
  faultMsgCountByTail(options) {
    const timeframe = options.timelineText || '1m'
    const startDate = startDateGivenTimeline(timeframe)
    const endDate = endDateGivenTimeline()
    const airlineIcaos = options.airlineIcaos
      .map(item => `&airlineICAOs=${item}`)
      .join('')
    let ataChapters = ''
    if (options.radioIndex === '0') {
      ataChapters = options.ataChapterIds
        .map(item => `&ataChapters=${item}`)
        .join('')
    }
    let messageCodes = ''
    if (options.radioIndex === '1') {
      messageCodes = options.messageCodeIds
        .map(item => `&messageCodes=${item}`)
        .join('')
    }

    const url = `/Dplf/MessageCounts/Tail?startDate=${startDate}&endDate=${endDate}${airlineIcaos}${ataChapters}${messageCodes}`
    return axios.get(url)
  },

  faultMsgCountByAtaChapter(options) {
    const timeframe = options.timelineText || '1m'
    const startDate = startDateGivenTimeline(timeframe)
    const endDate = endDateGivenTimeline()
    const tailNumber = options.tailNumber
    let ataChapters = ''
    if (options.radioIndex === '0') {
      ataChapters = options.ataChapterIds
        .map(item => `&ataChapters=${item}`)
        .join('')
    }
    let messageCodes = ''
    if (options.radioIndex === '1') {
      messageCodes = options.messageCodeIds
        .map(item => `&messageCodes=${item}`)
        .join('')
    }

    const url = `/Dplf/MessageCounts/TailAndAta?tailNumbers=${tailNumber}&startDate=${startDate}&endDate=${endDate}${ataChapters}${messageCodes}`
    return axios.get(url)
  },

  faultMsgCountByPara(options) {
    const timeframe = options.timelineText || '1m'
    const startDate = startDateGivenTimeline(timeframe)
    const endDate = endDateGivenTimeline()
    const tailNumber = options.tailNumber
    const ataChapter = options.ataChapter
    let messageCodes = ''
    if (options.radioIndex === '1') {
      messageCodes = options.messageCodeIds
        .map(item => `&messageCodes=${item}`)
        .join('')
    }

    const url = `/Dplf/MessageCounts/AtaAndPara?tailNumbers=${tailNumber}&ataChapters=${ataChapter}&startDate=${startDate}&endDate=${endDate}${messageCodes}`
    return axios.get(url)
  },

  faultMsgCodes(options) {
    const timeframe = options.timelineText || '1m'
    const startDate = startDateGivenTimeline(timeframe)
    const endDate = endDateGivenTimeline()
    const tailNumber = options.tailNumber
    const ataChapter = options.ataChapter
    const paras = options.paras
      .map(item => `&Para=${item.split('-')[1].trim()}`)
      .join('')
    let messageCodes = ''
    if (options.radioIndex === '1') {
      messageCodes = options.messageCodeIds
        .map(item => `&messageCodes=${item}`)
        .join('')
    }

    const url = `/Dplf/Messages?tailNumbers=${tailNumber}&ataChapters=${ataChapter}${paras}&startDate=${startDate}&endDate=${endDate}${messageCodes}&includeCorrelatedMessages=true`
    return axios.get(url)
  },

  faultReportsByFlight(options) {
    const timeframe = options.timelineText || '1m'
    const startDate = startDateGivenTimeline(timeframe)
    const endDate = endDateGivenTimeline()
    const airlineIcaos = options.airlineIcaos
      .map(item => `&airlineICAOs=${item}`)
      .join('')
    let ataChapters = ''
    if (options.radioIndex === '0') {
      ataChapters = options.ataChapterIds
        .map(item => `&ataChapters=${item}`)
        .join('')
    }

    const url = `/Dplf/MessageSummary?&startDate=${startDate}&endDate=${endDate}${airlineIcaos}${ataChapters}&includeCorrelatedMessages=true`
    return axios.get(url)
  },

  faultMsgDetails(options) {
    const tailNumber = options.tailNumber
    const fileLogId = options.fileLogId
    let ataChapters = ''
    if (options.radioIndex === '0') {
      ataChapters = options.ataChapterIds
        .map(item => `&ataChapters=${item}`)
        .join('')
    }
    const url = `/Dplf/Messages?tailNumbers=${tailNumber}&fileLogIDs=${fileLogId}${ataChapters}&includeCorrelatedMessages=true`
    return axios.get(url)
  },

  visualizeDetailsForTail(options) {
    const timeframe = options.timelineText || '1m'
    const startDate = startDateGivenTimeline(timeframe)
    const endDate = endDateGivenTimeline()
    const airlineIcao = options.airlineIcao
    const tailNumber = options.tailNumber
    const ataChapter = options.ataChapter
      ? `&ataChapters=${options.ataChapter}`
      : ''
    const messageCode = options.code
    const url = `/Dplf/MessageCounts/TailAndDate?airlineICAOs=${airlineIcao}${ataChapter}&tailNumbers=${tailNumber}&messageCodes=${messageCode}&startDate=${startDate}&endDate=${endDate}`
    return axios.get(url)
  },

  visualizeDetailsForFleet(options) {
    const timeframe = options.timelineText || '1m'
    const startDate = startDateGivenTimeline(timeframe)
    const endDate = endDateGivenTimeline()
    const airlineIcao = options.airlineIcao
    const ataChapter = options.ataChapter
      ? `&ataChapters=${options.ataChapter}`
      : ''
    const messageCode = options.code
    const url = `/Dplf/MessageCounts/Date?airlineICAOs=${airlineIcao}${ataChapter}&messageCodes=${messageCode}&startDate=${startDate}&endDate=${endDate}`
    return axios.get(url)
  },

  faultMsgRawReport(options) {
    const fileLogId = options.fileLogId || 0
    const airlineIcao = options.airlineIcao || '0'
    return axios.get(
      `/Dplf/FaultMsgRawReport?fileLogId=${fileLogId}&airlineICAO=${airlineIcao}`,
    )
  },

  messageCodesData(options) {
    const masterModelIds = options.masterModelIds
      .map((item, index) =>
        index === 0 ? `?masterModelIds=${item}` : `&masterModelIds=${item}`,
      )
      .join('')

    const url = `/Dplf/UniqueMessageCode${masterModelIds}`
    return axios.get(url)
  },

  ataChapters() {
    return axios.get('/AtaChapter/chapters')
  },
}

export default class DPLFService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
